import React from 'react';

import { SentimentVeryDissatisfied as SentimentVeryDissatisfiedIcon } from '@material-ui/icons';

import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles(({
  boxLoading : {
    backgroundColor : '#fff',
    boxShadow       : '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    marginTop       : 25,
    padding         : 24,
    paddingBottom   : 10
  },
}));

export default function PageError() {
  const classes = useStyle();

  return (
    <div className={classes.boxLoading}>
      <h1 align="center">
        <SentimentVeryDissatisfiedIcon align="center" fontSize="large"/><br />
        Error to get information. Try again later.
      </h1>
    </div>
  )
}